import clsx from "clsx"
import barcode from "@/assets/imgs/di-sini/barcode.png"
import ImageSkeleton from "../../../components/skeletons/ImageSkeleton"


const Barcode = ({ custCls }) => {
  return <ImageSkeleton src={barcode} alt="Contact person's barcode" custCls={`my-8 border-[6px] border-[#b99a59] rounded-2xl ${custCls}`} custStyle={`rounded-2xl my-8 ${custCls}`} custH="h-24 w-24" isBarcode />
}

export default Barcode